import { render, staticRenderFns } from "./MarketplaceProductsTableMobile.vue?vue&type=template&id=1987c74f&scoped=true"
import script from "./MarketplaceProductsTableMobile.vue?vue&type=script&lang=js"
export * from "./MarketplaceProductsTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1987c74f",
  null
  
)

export default component.exports